export class ApiCallClass {
    moduleName: String;
    data: String;
    method: String;
    sessionID: String;
    endUrl: String;
}
